import Axios from 'axios'
import {promoCodeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_promo_codes (context) {
    Axios.get(promoCodeUrls.getAllPromoCodes).then(function (response) {
      context.commit('GET_ALL_PROMO_CODES', response.data)
    })
  },
  get_promo_codes (context) {
    Axios.get(promoCodeUrls.getPromoCodes).then(function (response) {
      context.commit('GET_PROMO_CODES', response.data)
    })
  },
  get_inactive_promo_codes (context) {
    Axios.get(promoCodeUrls.getInActivePromoCodes).then(function (response) {
      context.commit('GET_INACTIVE_PROMO_CODES', response.data)
    })
  },
  make_promo_code_active (context, publicId) {
    Axios.get(promoCodeUrls.makePromoCodeActive + publicId).then(function () {
      context.dispatch('get_inactive_promo_codes')
      context.dispatch('get_all_promo_codes')
    })
  },
  make_promo_code_in_active (context, publicId) {
    Axios.get(promoCodeUrls.makePromoCodeInActive + publicId).then(function () {
      context.dispatch('get_inactive_promo_codes')
      context.dispatch('get_all_promo_codes')
    })
  },
  get_deleted_promo_codes (context) {
    Axios.get(promoCodeUrls.getDeletedPromoCode).then(function (response) {
      context.commit('GET_DELETED_PROMO_CODES', response.data)
    })
  },
  get_promo_code (context, publicId) {
    Axios.get(promoCodeUrls.getPromoCode + publicId).then(function (response) {
      context.commit('GET_PROMO_CODE', response.data)
    })
  },
  post_promo_code (context, data) {
    Axios.post(promoCodeUrls.postPromoCode, data).then(function () {
      context.dispatch('get_all_promo_codes')
      router.push({
        name: 'GeneratePromoCodes'
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_promo_code (context, data) {
    Axios.post(promoCodeUrls.editPromoCode + data.public_id, data).then(function () {
      context.dispatch('get_all_promo_codes')
      router.push({
        name: 'PromoCodes'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  promo_code_usage (context, publicId) {
    Axios.get(promoCodeUrls.getPromoCodeUsage + publicId).then(function (response) {
      context.commit('GET_PROMO_CODE_USAGE', response.data)
    })
  },
  delete_promo_code (context, data) {
    Axios.post(promoCodeUrls.deletePromoCode + data, { deleted_by: localStorage.getItem('lkjhgfdsa') }).then(function (response) {
      context.dispatch('get_all_promo_codes')
    })
  },
  restorePromoCode (context, publicId) {
    Axios.get(promoCodeUrls.restorePromoCode + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PROMO_CODES', response.data)
      router.push({
        name: 'Module.PromoCodes'
      })
    })
  }
}
